<template>
  <v-container>
    <v-row>
      <v-col>
        <client-goals :userId="userId"/>
      </v-col>
    </v-row>
    <v-row v-if="!loading">
      <v-col>
        <v-card>
          <v-card-title>
            Weight loss goals
          </v-card-title>
          <v-card-text>
            <h4>Current weight</h4>
            <p>{{user.userProfile.weight}} kg</p>
            <h4>Weight Goal</h4>
            <p>{{user.userProfile.desiredWeight}} kg</p>
            <h4>Weight Loss Goal</h4>
            <p>{{user.userProfile.desiredWeightLoss}} kg</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ClientGoals from "./ClientGoals";
import { CLIENT_ONBOARDING_GOALS_QUERY } from "@/constants/graphql/goal/goal";

export default {
  name: "ClientGoalsList",
  components: {
    ClientGoals,
  },
  props: ["userId"],
  data() {
    return {
      user: null,
      loading: true
    }
  },
  apollo: {
    user: {
      query: CLIENT_ONBOARDING_GOALS_QUERY,
      variables() {
        let encoded_json_payload =btoa("UserNode:" + this.userId);
        return {
          id: encoded_json_payload,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
        }
      },
    },
  },
}
</script>
